import api from '../api';

/** 欢迎页：获取已启用的轮播/专题位 */
export function getActiveHomeOperationSlots() {
  return api.get('/welcome/operation-slots');
}

/** 后台：列表 */
export function listHomeOperationSlots(slotType) {
  return api.get('/admin/home-operation-slots', {
    params: slotType ? { slotType } : {},
  });
}

/** 后台：新增 */
export function createHomeOperationSlot(payload) {
  return api.post('/admin/home-operation-slots', payload);
}

/** 后台：更新 */
export function updateHomeOperationSlot(id, payload) {
  return api.put(`/admin/home-operation-slots/${id}`, payload);
}

/** 后台：删除 */
export function deleteHomeOperationSlot(id) {
  return api.delete(`/admin/home-operation-slots/${id}`);
}

/** 上传运营位图片 */
export async function uploadOperationSlotImage(file) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('imageType', 'images');
  const res = await api.post('/upload/image', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  if (!res?.data?.success || !res?.data?.url) {
    throw new Error(res?.data?.message || '图片上传失败');
  }
  return res.data.url;
}
